import ManageConnectionsPage from './ManageConnections';
import { createManageConnectionsHandle } from './handle';

export default {
  Component: ManageConnectionsPage,
  createHandle: createManageConnectionsHandle
};
